import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { DebtCollect } from "./type";

const path = "report";

export interface ReportInterface {
  start_date?: string;
  end_date?: string;
  type?: string;
  type_doc?: string;
}

export type sale_tax_data = {
  date: string;
  branchId: number;
}

/**
 * query ของรายงาน "รายการชำระเงิน" — ใช้ชุดเดียวกันทั้งเส้น JSON และเส้นดาวน์โหลด
 *
 * ไม่ส่ง field ไหน = ไม่กรองด้วย field นั้น (อย่าส่งค่าว่างมา ให้ตัด key ออกเลย)
 * ช่วงวันที่ผูกกับ `invoice.invoiceDate` (วันที่ออกใบแจ้งหนี้) ไม่ใช่วันที่ชำระจริง
 */
export interface PaymentListReportParams {
  /** yyyy-MM-dd */
  start_date?: string;
  end_date?: string;
  zoneId?: number;
  stallId?: number;
  paymentServiceId?: number;
  leaseAgreementTypeId?: number;
  branchId?: number;
  keyword?: string;
  /** page/pageLimit ใช้ได้เฉพาะ /payment-list — เส้นดาวน์โหลดเอาทุกแถวที่ผ่าน filter */
  page?: number;
  pageLimit?: number;
}

export default class ReportApi extends BaseAPI {
  static getAgreement(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/agreement", { params: { ...params } })
      .then((res) => res);
  }

  static getBankContract(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/bank-contract", { params: { ...params } })
      .then((res) => res);
  }

  static getRevenueCollection(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/revenue-collection", { params: { ...params } })
      .then((res) => res);
  }

  static getUtilities(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/utilities", { params: { ...params } })
      .then((res) => res);
  }
  //
  static downloadAgreement(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/download-agreement", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static downloadBankContract(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/download-bank-contract", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static downloadRevenueCollection(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/download-revenue-collection", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static downloadUtilities(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/download-utilities", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static downloadPaymentList(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/download-invoice-pay", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }
  static downloadIndividualDebtor(params: ReportInterface): Promise<any> {
    return this.api
      .get(path + "/individual-debtor", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static downloadSaleTax(params: sale_tax_data): Promise<any> {
    return this.api
      .get(path + "/download-sale-tax", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }


  static debtCollect(params: DebtCollect): Promise<AxiosResponse> {
    return this.api.get(`${path}/invoice/debt-collect`, { params, responseType: 'arraybuffer' })
  }

  /**
   * ตารางรายงานรายการชำระเงิน (ใบที่ชำระแล้ว แยกรายประเภทค่าบริการ)
   * คืน { status, message, data: [], summary: {}, total, page, pageLimit }
   */
  static getPaymentList(params: PaymentListReportParams): Promise<any> {
    return this.api
      .get(path + "/payment-list", { params: { ...params } })
      .then((res) => res);
  }

  /**
   * ไฟล์ Excel ของตารางด้านบน — ข้อมูลตรงกันเพราะใช้ query/mapping ก้อนเดียวกัน
   * ต่างกันจุดเดียว: ไฟล์เอาทุกแถวที่ผ่าน filter ไม่ได้ตัดเฉพาะหน้าที่เปิดอยู่ (จึงไม่ส่ง page/pageLimit)
   *
   * ชื่อไม่ซ้ำกับ downloadPaymentList ด้านบนโดยตั้งใจ — เส้นนั้นคือ /download-invoice-pay
   * ซึ่งเป็นรายงานฝั่งใบเสร็จ อิง payment.effDate คนละมุมกับเส้นนี้ และยังมีที่เรียกใช้อยู่
   */
  static downloadPaymentListReport(params: PaymentListReportParams): Promise<any> {
    return this.api
      .get(path + "/download-payment-list", {
        params: { ...params },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

}
